var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "fire_svg__a",
    d: "M0 0h5.937v6.302H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fire_svg__b",
    d: "M0 0h2.558v1.375H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fire_svg__c",
    d: "M0 0h9.9v14.76H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-357 -1258)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319 1237)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    fill: "#FCFCFC",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.14 22.62)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fire_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fire_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.965 5.198c-.431-1.065-1.03-1.664-1.444-2.006.206 1.118-.51 2.688-.629 2.13C6.583 3.88 5.759 1.236 3.373 0c.21 6.01-3.72 5.333-3.348 10.103.156 2.007 1.32 3.732 3.035 4.434-.746-.532-1.27-1.403-1.27-2.31 0-.742.045-1.657.505-2.54.065-.126.571-.924.802-1.114-.115.62.283 1.493.35 1.183.17-.802.628-2.27 1.953-2.956-.116 3.338 2.066 2.962 1.86 5.611-.08 1.019-.627 1.906-1.447 2.349 2.178-.483 3.918-2.478 4.06-4.99.165-2.894-.476-3.506-.908-4.572",
    mask: "url(#fire_svg__d)"
  }))))));
};
export default SvgFire;